<div *ngIf="!!this.shellConfigService.shellParameter?.variantenvergleich">
  <lv-uiartefakt-container class="lv-votum-box-content"
                           [uiArtefakte]="uiArtefakt.UIArtefakt"></lv-uiartefakt-container>
</div>
